import { render } from "./CCWNAbnormalCallList.vue?vue&type=template&id=47675e1a&scoped=true"
import script from "./CCWNAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./CCWNAbnormalCallList.vue?vue&type=script&lang=js"

import "./CCWNAbnormalCallList.vue?vue&type=style&index=0&id=47675e1a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47675e1a"

export default script